export const PORTAL_NAME_LIMIT = 25
export const PORTAL_DES_LIMIT = 400
export const WALLET_CONNECT = 'wallet-connect-btn'
export const STATIC_NONCE_FOR_PORTAL_RECOVERY = '5uxi25zk'
export const SESSION_HOST_FLAG = 'host'
export const GNOSIS_MAX_QUERY_RANGE = 10000
export const GNOSIS_SAFE_APP_URL = 'https://app.safe.global/'
export const JSON_CONTENT_TYPE = 'application/json'
